import type { ReactNode } from 'react';

interface Props {
  icon: string;
  title: string;
  children: ReactNode;
}

export default function ({ icon, title, children }: Props) {
  return (
    <div className="mb-8 space-y-1 rounded border-b-1 pb-4">
      <h3 className="text-base font-medium">
        <span aria-hidden="true">{icon}</span> {title}
      </h3>
      <div>{children}</div>
    </div>
  );
}
